var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var _a;
import { REACT_APP__URL_EASYPOST_BASE } from "@smp/utils";
import { apiRequest } from "../../../../lib";
export class ApiEpSocialAccountConnectYoutube {
}
_a = ApiEpSocialAccountConnectYoutube;
ApiEpSocialAccountConnectYoutube.list = () => __awaiter(void 0, void 0, void 0, function* () {
    return apiRequest({
        endpoint: `${REACT_APP__URL_EASYPOST_BASE}api/v1/social-account/connect/youtube`,
        method: "GET",
    });
});
ApiEpSocialAccountConnectYoutube.create = (req) => apiRequest({
    body: req.body,
    endpoint: `${REACT_APP__URL_EASYPOST_BASE}api/v1/social-account/connect/youtube`,
    method: "POST",
});
//# sourceMappingURL=youtube.js.map